import React from 'react';
import { canAccessTab } from '../utils/rbac';

/**
 * Wraps a UI section and only renders it when the current user has
 * permission to access the given tab.
 *
 * Example:
 *   <RoleGate tabId="generalLedger" userRole={userRole} currentUser={currentUser}>
 *     <GeneralLedger />
 *   </RoleGate>
 *
 * When access is denied, an inline "Access denied" panel is shown instead
 * of the child content. This guards the UI only; the backend is the
 * authoritative source of truth for permissions.
 */
const RoleGate = ({ tabId, userRole, currentUser, fallback = null, children }) => {
  if (canAccessTab(userRole, tabId, currentUser)) {
    return <>{children}</>;
  }

  if (fallback) return <>{fallback}</>;

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        padding: '40px 20px',
        textAlign: 'center',
        background: '#fef3c7',
        border: '1px solid #f59e0b',
        borderRadius: '8px',
        margin: '20px',
      }}
    >
      <h2 style={{ color: '#92400e', margin: '0 0 12px' }}>Access denied</h2>
      <p style={{ color: '#78350f', margin: 0 }}>
        Your role ({userRole || 'unknown'}) does not have permission to view this section.
        Please contact your administrator if you believe this is an error.
      </p>
    </div>
  );
};

export default RoleGate;
